import React from "react";

import { MdmObjectDto, useGetObjectsByProjectQuery } from "gql/generated/types";
import { Link } from "react-router-dom";
import { TableColumn } from "utils/types";
import MainTable from "../components/MainTable";
import useProjectContext from "../hooks/useProjectContext";


const Objects = () => {
  const {projectId} = useProjectContext();

  const { data: objectData, loading } = useGetObjectsByProjectQuery({
    variables: { id: projectId! },
    skip: !projectId,
  });

  const objectInfoBtn = (rowData: MdmObjectDto) => (
    <Link to={`objects/${rowData.id}`} title="Object Info">
      {rowData.title}
    </Link>
  );

  const columns: TableColumn<MdmObjectDto>[] = [
    { field: "title", header: "Object Code", body: objectInfoBtn, sortable: true },
    {
      field: "address.fullAddress",
      header: "Address",
      sortable: true,
    },
  ];

  return (
    <MainTable
      columns={columns}
      data={objectData?.mdmObjectsByProjectId ?? []}
      tableType="object"
      searchFields={["title", "address.fullAddress"]}
      loading={loading}
    />
  );
};

export default Objects;
